<script>
    /*
    	ListActionBar.svelte

        need to check user.idTokenClaims.roles for allowed actions
        import { AccountStore } from "../../common/account";

        if the user role is in the action roles show a button


    */

    import { onMount } from 'svelte';
    import { ROLE_SEARCH, ROLE_READ, ROLE_REVIEW_WRITE } from '../../common/roles-actions.js';

    // TCARE components
	import ListActionButton from './ListActionButton.svelte';
    import { AccountStore } from "../../common/account";

    // SMUI components

    export let selectedCount;
    export let actions;

    let userRoles = $AccountStore.roles;

    onMount(() => {
        // console.log('');
        // console.log('ListActionBar onMount');
        // console.log('userRoles:');
        // console.log(userRoles);
    })

</script>

<style>
    .action-bar-wrapper {
        position: relative;
        width: 95%;
        margin-left: 5%;
        margin-bottom: 20px;
        /* background-color: var(--tcare-cream); */
    }

    .action-bar-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .action-bar-wrapper .overlay {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: var(--tcare-gray);
        /* opacity: .2; */
        opacity: 0;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<div class="action-bar-wrapper">
    <div class="action-bar-buttons">
        {#each actions as action}
                    <ListActionButton {action} {selectedCount} />
        {/each}
    </div>
    {#if selectedCount < 1}
        <div class="overlay"></div>     <!-- prevent hovers and clicks -->
    {/if}
</div>

